import type { UpdatePersonDto } from '../dto';
import type { UpdatePerson } from '../models';

export const mapUpdatePersonToDto = (model: UpdatePerson): UpdatePersonDto => ({
  ...model,
});
